/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ExecutiveInputs */

const en_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const es_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutivo`)
};

const fr_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirigeants`)
};

const de_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führungskräfte`)
};

const ja_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エグゼクティブコーチング`)
};

const zh_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`企业高管指导`)
};

const ar_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إداري / تنفيذي`)
};

const id_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksekutif`)
};

const it_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const ru_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для руководителей`)
};

const pt_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executivo`)
};

const ko_val_executive = /** @type {(inputs: Val_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경영자 코칭`)
};

/**
* | output |
* | --- |
* | "Executive" |
*
* @param {Val_ExecutiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_executive = /** @type {((inputs?: Val_ExecutiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ExecutiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_executive(inputs)
	if (locale === "es") return es_val_executive(inputs)
	if (locale === "fr") return fr_val_executive(inputs)
	if (locale === "de") return de_val_executive(inputs)
	if (locale === "ja") return ja_val_executive(inputs)
	if (locale === "zh") return zh_val_executive(inputs)
	if (locale === "ar") return ar_val_executive(inputs)
	if (locale === "id") return id_val_executive(inputs)
	if (locale === "it") return it_val_executive(inputs)
	if (locale === "ru") return ru_val_executive(inputs)
	if (locale === "pt") return pt_val_executive(inputs)
	return ko_val_executive(inputs)
});